<template>
  <master-main
    :addProperties="{
      isWizard: false,
    }"
    :exportProperties="{
      pdf: {
        filename: `${$t('inventory.cost_centers')}_${dateToday}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('inventory.cost_centers')}_${dateToday}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('inventory.supplyings'),
        data: 'supplyings',
        property: 'name',
        minWidth: 200,
      },
      {
        columnLabel: $t('common_words.allotments'),
        data: 'lots',
        property: 'name',
        minWidth: 180,
      },
      {
        columnLabel: $t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 180,
      },
    ]"
    :route="getModuleRoute"
    :showProperties="showProperties"
    :tableProperties="tableProperties"
    @closeModal="handleCloseModal"
    @openModal="handleOpenModal"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
  >
    <template slot="dialogForm">
      <edit-or-create
        v-if="renderComponent"
        :syncDialog="modals"
        @addEdit="addEdit"
        @closeModal="handleCloseModal"
        @showHideLoading="showHideLoading"
        @showNotification="notifyVue"
        ref="editCreate"
      />
    </template>
  </master-main>
</template>
<script>
import EditCreate from 'src/views/Pages/Dashboard/Supplying/Inventory/CostCenter/EditCreate.vue';
import { getDateToday } from 'src/util/Util';
import CostCenterTable from 'src/views/Pages/Dashboard/Supplying/Inventory/CostCenter/cost-centers-table';
import i18n from 'src/i18n';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinRerender from 'src/mixins/mixin-rerender';
import MixinWithDialog from 'src/mixins/master/mixin-with-dialog';

export default {
  components: {
    MasterMain,
    [EditCreate.name]: EditCreate,
  },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '70%' },
    };
  },
  mixins: [
    MixinAlert,
    MixinLoading,
    MixinForm,
    MixinMain,
    MixinPermissions,
    MixinWithDialog,
    MixinRerender,
    MixinMenu,
  ],
  computed: {
    getModuleRoute() {
      return 'inventory/costcenter';
    },
    buildTableProperties() {
      return {
        tableColumns: [...CostCenterTable().tableColumns],
        model: 'costcenter',
        effectTags: 'dark',
        defaultSort: { prop: 'name', order: 'ascending' },
        addColumns: [
          {
            label: i18n.t('inventory.supplyings'),
            data: 'supplyings',
            field: 'name',
          },
          {
            label: i18n.t('common_words.allotments'),
            data: 'lots',
            field: 'name',
          },
        ],
      };
    },
    dateToday() {
      return getDateToday();
    },
  },
};
</script>
